module.exports = __webpack_public_path__ + "media/images/cleaning/cover-desktop@2x-63b123ff34aea56914a29fb97eb51289.jpg";